/* eslint-disable max-len */
import styles from "./Pricing.module.css";
import ButtonArr from "../../components/Button/ButtonArr";
import { useEffect, useState } from "react";
import PriceCard, { resolveFrequencyPrice } from "../../components/Pricing/components/PriceCard";
import { Grid, Box, Tabs, Tab } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import axios from "axios";

// USED TO STYLE THE TABLE
const tableCellHeaderStyle = { fontWeight: "400", fontSize: "18px", lineHeight: "21.6px", borderBottom: "0px", color: "rgba(169, 169, 169, 1)", padding: "0px 16px 35px 16px" };
const tableSubDescStyle = { fontWeight: "700", fontSize: "24px", lineHeight: "36px", borderBottom: "0px" };

const PRICING_ENDPOINT = `${process.env.REACT_APP_API_URL}/api/v1/pricing-plans?include_variants=true`;

const billingTabsSx = {
  "& .MuiTab-root.Mui-selected": {
    background: "#0065FF",
    color: "#FFF",
    borderRadius: "8px"
  },
  "& button": {
    color: "#0065FF",
    fontSize: "20px",
    fontWeight: "700",
    paddingInline: "78px",
    textTransform: "none",
    minHeight: "48px"
  },
  "& button:hover": {
    backgroundColor: "#0065FF",
    color: "#FFF",
    transition: "0.3s",
    borderRadius: "8px"
  },
  "& button:not(:last-child)": {
    marginRight: "8px"
  },
  "@media (max-width: 600px)": {
    "& button": {
      paddingInline: "28px",
      fontSize: "16px"
    }
  }
};

const PricePage = () => {
  const [pricingModels, setPricingModels] = useState([]);
  const [billingPeriod, setBillingPeriod] = useState("monthly");

  const createData = (name, basic, premium, enterprise) => {
    return { name, basic, premium, enterprise };
  };

  const tableone = [
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Users</p></span>, "Up to 99 Students", "Up to 699 Students", "From 699 Students"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Payment Management</p>  </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Analytics Dashboard</p>  </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Sessions</p> </span>, "Unlimited", "Unlimited", "Unlimited"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Terms</p> </span>, "Unlimited", "Unlimited", "Unlimited"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Classes</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Subjects</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Assesments</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Lesson Notes</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>CBT</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Applicant Portal</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Invoice Notifications</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Third Party Integrations</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Enrollments and Application</p> </span>, "50 student application Per enrollment", "Unlimited", "Unlimited"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Online Support</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>AI Web Chat</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Sending Bulk Emails</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Guides and Explainer Videos</p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Report Templates </p> </span>, "1", "unlimited", "unlimited"),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Data Export(Csv, Doc, Pdf) </p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Batch Data Import </p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Branding </p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Mobile App </p> </span>, <DoneIcon />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Lesson Note Review </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Attendance </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>CA Audits </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Hostel Management </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>School Plans/Calendar</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Access Control </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Audit logs </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Inventory management </p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Library Managment</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Event Management</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Account Transfer</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Question Bank</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Exam Timetable</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Enrollment Examination</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Custom Academic Reports</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Roles and Permissions</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Email Subscriber List</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Email Templates</p> </span>, <ClearIcon style={{ color: "red" }} />, <DoneIcon />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Multi School Managment</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Dedicated Server</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Account Manager</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>Custom Features</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />),
    createData(<span className="flex gap-8 align-item-center"><p className={`${styles.tabledata}`}>School Custom Domain</p> </span>, <ClearIcon style={{ color: "red" }} />, <ClearIcon style={{ color: "red" }} />, <DoneIcon />)
  ];

  const handleGetStart = () => {
    window.open(process.env.REACT_APP_URL, "_blank");
  };

  const handleBillingChange = (_event, newValue) => {
    setBillingPeriod(newValue);
  };

  const fetchPricingModels = async () => {
    try {
      const res = await axios.get(PRICING_ENDPOINT);
      const filteredModels = res?.data?.data?.filter(
        (model) => model?.model_name !== "Partner" && model?.name !== "Partner"
      );
      const sortedModels = filteredModels?.sort((a, b) => {
        const priceA = resolveFrequencyPrice(a?.billing_frequency, "monthly", a?.price);
        const priceB = resolveFrequencyPrice(b?.billing_frequency, "monthly", b?.price);

        return priceA - priceB;
      });

      setPricingModels(sortedModels || []);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err.response?.data?.message || "Error fetching pricing models");
    }
  };

  useEffect(() => {
    fetchPricingModels();
  }, []);

  const freeFeatures = [
    "Up to 99 Students", "Comprehensive Dashboard", "Payments Management", "Reports Management", "Up to 50 Applications/Enrollment", "NULL", "NULL", "NULL"
  ];

  const proFeatures = [
    "Up to 699 Students", "Comprehensive Dashboard", "Payments Management", "Reports Management", "Unlimited Applications/Enrollments", "Hostel Management", "Examination Timetable", "Roles and Permissions"
  ];
  const enterpiseFeatures = [
    "From 699 Students", "Comprehensive Dashboard", "Payments Management", "Reports Management", "Unlimited Applications/Enrollments", "Hostel Management", "Examination Timetable", "Roles and Permissions"
  ];

  const getPlanFeatures = (planName) => {
    if (planName === "Free") return freeFeatures;
    if (planName === "Pro") return proFeatures;
    if (planName === "Enterprise") return enterpiseFeatures;

    return [];
  };

  const renderPricingCards = (duration) => {
    const payType = duration === "quarterly" ? "Quarter" : "Month";

    return (
      <Grid container spacing={2} justifyContent="center">
        {pricingModels.map((model) => {
          const displayPrice = resolveFrequencyPrice(
            model.billing_frequency,
            duration,
            model.price
          );

          return (
            <Grid item lg={4} md={6} sm={6} xs={12} key={`${model.id}-${duration}`}>
              <PriceCard
                amount={`₦${displayPrice.toLocaleString("en-US")}`}
                price={displayPrice}
                billingFrequency={model.billing_frequency}
                payType={payType}
                planType={model.name}
                planDescription={model.description}
                modelId={model.id}
                status={model.active}
                features={getPlanFeatures(model.name)}
                variant={model.has_variant}
                variants={model.variants}
                currencyCode={model.currencyCode}
                duration={duration}
                maxUsers={model.max_users}
              />
            </Grid>
          );
        })}
      </Grid>
    );
  };

  return (
    <div>
      <div className={`${styles.herosectionbcg}`}>
        <div className={`${styles.container}`}>
          <div className={`${styles.contmargin}`}>
            <div className={`${styles.priceheader}`}>
              <h1>
              With little or no cash you can get started with managing your school and
              teams.
              </h1>
              <h4>
              Empowering Schools, Engaging Students, and Connecting Parents, all
              in one platform.
              </h4>
              <div className={`${styles.getstartedbtn}`}>
                <ButtonArr onClick={handleGetStart} title="Get Started" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* PRICING */}
      <div className={`${styles.pricingcontainer}`}>
        <div className={`${styles.container}`}>
          <div className={`${styles.contmargin}`}>
            <div className={`${styles.pricingheader}`}>
              <h3>Shelf21 Pricing Options</h3>
              <p>
                Record and report on safeguarding information including
                background checks, and safer recruitment trainingRecord and
                report on safeguarding.
              </p>
            </div>
            <div className={`${styles.shelfpricing}`}>
              <TabContext value={billingPeriod}>
                <Box className={styles.billingToggle}>
                  <Tabs
                    onChange={handleBillingChange}
                    TabIndicatorProps={{ style: { display: "none" } }}
                    value={billingPeriod}
                    centered
                    sx={billingTabsSx}
                  >
                    <Tab label="Monthly" value="monthly" />
                    <Tab label="Quarterly" value="quarterly" />
                  </Tabs>
                </Box>
                <TabPanel value="monthly" sx={{ padding: 0 }}>
                  {renderPricingCards("monthly")}
                </TabPanel>
                <TabPanel value="quarterly" sx={{ padding: 0 }}>
                  {renderPricingCards("quarterly")}
                </TabPanel>
              </TabContext>
            </div>
          </div>
        </div>
      </div>
      {/* PLANS AND FEATURES */}
      <div className={`${styles.container}`}>
        <div className={`${styles.contmargin}`}>
          <div className={`${styles.planandfeatures}`}>
            <div className={`${styles.compareplansheader}`}>
              <h3>Compare Plans</h3>
              <p>
                  Choose a subscription that fits your current need and get
                  right on it.
              </p>
            </div>
            <TableContainer component={Paper} sx={{ boxShadow: "0px 0px 0px 0px" }}>
              <Table sx={{ minWidth: 650, borderColor: "white" }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" sx={tableSubDescStyle}></TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}>Basic</TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}>Pro</TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}>Enterprise</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="center" sx={tableCellHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableCellHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableCellHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableCellHeaderStyle}>On request</TableCell>
                  </TableRow>
                  <TableRow>
                    {/* <TableCell sx={{ fontWeight: "700", fontSize: "20px", lineHeight: "24px", borderBottom: "0px" }}>WORKSPACE MANAGEMENT</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableone.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:nth-of-type(odd)": { backgroundColor: "#F9F9FB" }
                      }}
                    >
                      <TableCell component="th" scope="row" sx={{ borderBottom: "0px" }}>
                        {row.name}
                      </TableCell>
                      <TableCell align="center" sx={{ borderBottom: "0px" }}>{row.basic}</TableCell>
                      <TableCell align="center" sx={{ borderBottom: "0px" }}>{row.premium}</TableCell>
                      <TableCell align="center" sx={{ borderBottom: "0px" }}>{row.enterprise}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                {/* SECOND TABLE */}
                {/* <TableHead sx={{ marginTop: "50px" }}>
                  <TableRow>
                    <TableCell sx={tableSubHeaderStyle}>SCHOOL BRANDING</TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}></TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}></TableCell>
                    <TableCell align="center" sx={tableSubDescStyle}></TableCell>
                  </TableRow>
                </TableHead> */}
                {/* THIRD TABLE */}
                {/* <TableHead>
                  <TableRow>
                    <TableCell sx={tableSubHeaderStyle}>EXPORTS</TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                  </TableRow>
                </TableHead> */}

                {/* FOURTH TABLE */}
                {/* <TableHead>
                  <TableRow>
                    <TableCell sx={tableSubHeaderStyle}>SUPPORTS</TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                    <TableCell align="center" sx={tableSubHeaderStyle}></TableCell>
                  </TableRow>
                </TableHead> */}
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricePage;
